import React, { useContext, useEffect, useState } from "react";
import TableHeader from "../Utility/TableHeader";
import TopStats from "../Utility/TopStats";
import LabelTopView from "../Utility/LabelTopView";
import { ShoppingBagIcon } from "lucide-react";
import {
  CurrencyDollarIcon,
  CurrencyRupeeIcon,
} from "@heroicons/react/24/solid";
import TopFilters from "../Utility/TopFilters";
import { DataContext } from "../../helper/HelperOne";
import axios from "axios";

function ProductwiseReportList() {
  const headers = [
    "S No",
    "Product",
    "Quotation No",
    'Quantity',
    "Lead",
   "Amount",
    // "Actions",
  ];

  const { searchData } = useContext(DataContext);
  const [products, setProducts] = useState([]);
  const [paginationProductsDatas, setPaginationProductsDatas] = useState([]);

  const [filterParams, setFilterParams] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const taskBasedOnLead = {
    tasks: {
      data: [
        {
          id: 1,
          id_crypt: "abc123",
          task_name: "Follow-up Call",
          lead_name: { name: "John Doe" },
          start_date: "2024-04-01",
          end_date: "2024-04-05",
          amount: "1000",
        },
        {
          id: 2,
          id_crypt: "def456",
          task_name: "Send Proposal",
          lead_name: { name: "Jane Smith" },
          start_date: "2024-04-02",
          end_date: "2024-04-06",
          amount: "1000",
         
        },
        {
          id: 3,
          id_crypt: "ghi789",
          task_name: "Negotiation Meeting",
          lead_name: { name: "Michael Johnson" },
          start_date: "2024-04-03",
          end_date: "2024-04-07",
          amount: "1000",
          
        },
        {
          id: 4,
          id_crypt: "jkl101",
          task_name: "Contract Signing",
          lead_name: { name: "Sarah Williams" },
          start_date: "2024-04-04",
          end_date: "2024-04-08",
          amount: "1000",
        
        },
      ],
    },
  };

  const fetchProducts = async (page = 1, queryParams = "") => {
    try {
      const token = localStorage.getItem("token");
      const productUrl = `public/api/admin/product/pagination?page=${page}${
        queryParams ? `&${queryParams}` : ""
      }${searchData ? `&search=${encodeURIComponent(searchData)}` : ""}`;

      const response = await axios.get(productUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log(response.data.products.data, "hello");

      setProducts(response.data.products.data);
      setPaginationProductsDatas(response.data.products);
      setCurrentPage(response.data.products.current_page);
    } catch (error) {
      console.error("Error fetching products:", error);
      return [];
    }
  };

  useEffect(() => {
    fetchProducts(currentPage, filterParams);
  }, [searchData, currentPage, filterParams]);

  const [filterData, setFilterData] = useState({
    product_name: "",
    count: "",
    product_cost: "",
  });

  const statsFieldNames = [
    {
      title: "Total Products",
      value: products.length,
      color: "blue",
      bg: "bg-blue-50",
      link: "/crm/products",
    },
    {
      title: "Goods",
      value: products?.filter((item) => item.code_type === "HSN").length,
      color: "green",
      bg: "bg-green-50",
      link: "/crm/products/goods",
    },
    {
      title: "Service",
      value: products?.filter((item) => item.code_type === "SAC").length,
      color: "yellow",
      bg: "bg-yellow-50",
      link: "/crm/products/service",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFilter = () => {
    const queryParams = new URLSearchParams();

    if (filterData.product_name?.trim()) {
      queryParams.append("product_name", filterData.product_name.trim());
    }
    if (filterData.count) {
      queryParams.append("count", filterData.count);
    }
    if (filterData.product_cost) {
      queryParams.append(
        "product_cost",
        Number(filterData.product_cost).toFixed(2)
      );
    }

    setFilterParams(queryParams.toString()); // ✅ Store query params
    fetchProducts(1, queryParams.toString()); // ✅ Fetch data with filters applied
  };

  const handleReset = async () => {
    setFilterData({ product_name: "", count: "", product_cost: "" });
    await fetchProducts();
  };

  const fields = [
    {
      name: "product_name",
      type: "text",
      placeholder: "Enter Name",
      componentType: "select",
      options: products.map((product) => ({
        value: product.product_name,
        label: product.product_name,
      })),
    },
    {
      name: "product_cost",
      type: "text",
      placeholder: "Enter Cost",
      componentType: "select",
      options: products.map((product) => ({
        value: parseInt(product.product_cost),
        label: parseInt(product.product_cost),
      })),
    },
  ];

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-2">
        <LabelTopView label="Product Wise Overview" />
        <div className="border sm:border-0 px-2 rounded flex items-center justify-start sm:justify-end">
          <h2 className="text-md  font-semibold text-gray-800 flex items-center justify-start sm:justify-end gap-2 whitespace-nowrap">
            <CurrencyRupeeIcon className="h-6 w-6 text-green-600" />
            Total Sales:
          </h2>
          <span className="text-md font-bold text-green-700 whitespace-nowrap">
           
          </span>
        </div>
      </div>

      <TopStats statsFieldNames={statsFieldNames} />

      <TopFilters
        fields={fields}
        filterData={filterData}
        handleChange={handleChange}
        handleFilter={handleFilter}
        handleReset={handleReset}
      />

      <div className="overflow-x-auto mt-8">
        <table className="min-w-full divide-y divide-gray-300">
          <TableHeader headers={headers} />

          <tbody className="divide-y divide-gray-200 bg-white">
            {products?.map((product, index) => (
              <tr
                key={product.id}
                className="hover:bg-gray-50 transition duration-300 ease-in-out "
              >
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center p-4">
                  {index + 1}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center p-4">
                  {product.product_name}
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center p-4">
                  25
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center p-4">
                  47
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center p-4">
                    Kumaresh
                </td>
                <td className="whitespace-nowrap text-md uppercase sm:pl-4 text-center p-4">
                {product.product_cost}

                </td>
                {/* <td className="flex space-x-2 items-center justify-center py-4 text-center text-sm text-gray-500 font-semibold">
                  {taskPermissionForDiscussion && (
                    <LeadDiscusstion
                      id_crypt={task.id_crypt}
                      leadId={task.id}
                      setLeadDiscusstion={setLeadDiscusstion}
                    />
                  )}

                  {taskPermissionForView && (
                    <span
                      className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                      onClick={(e) => handleViewForLead(e,task.id_crypt)}
                    >
                      <EyeIcon className="h-5 w-5 text-white" />
                      <Tooltip
                        anchorSelect=".my-anchor-view"
                        place="top"
                        className="text-xs p-0"
                      >
                        View
                      </Tooltip>
                    </span>
                  )}

                  {taskPermissionForDelete && (
                    <DeleteConfirmation
                      id_crypt={task.id_crypt}
                      apiType="lead_task"
                      fetchClientData={fetchLeadDatasForTask}
                    />
                  )}
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default ProductwiseReportList;
